// @flow
import * as React from 'react';
import {
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  // $FlowFixMe
} from '@mui/material';

import { Controller, useWatch } from 'react-hook-form';

import { OTHER_OPTION, isOtherSelected } from 'Constants/installationAsBuild';

type Props = {|
  name: string,
  control: Object,
  setValue: Function,
  options: Array<string>,
  errors: Object,
  otherPlaceholder: string,
  otherMultiline?: boolean,
  otherRows?: number,
|};

function RadioWithOtherField(props: Props): React.Node {
  const {
    name,
    control,
    setValue,
    options,
    errors,
    otherPlaceholder,
    otherMultiline = false,
    otherRows = 4,
  } = props;
  const watchedValue = useWatch({ control, name });
  const showOtherField = isOtherSelected(watchedValue);
  const fieldError = errors[name];

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <RadioGroup
          value={
            isOtherSelected(field.value) ? OTHER_OPTION : field.value || ''
          }
          onChange={(event) => {
            const nextValue = event.target.value;

            if (nextValue === OTHER_OPTION) {
              field.onChange(OTHER_OPTION);
            } else {
              setValue(`${name}.other`, '', { shouldDirty: true });
              field.onChange(nextValue);
            }
          }}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio />}
              label={option}
            />
          ))}

          <FormControlLabel
            value={OTHER_OPTION}
            control={<Radio />}
            label={OTHER_OPTION}
          />

          {showOtherField && (
            <Controller
              name={`${name}.other`}
              control={control}
              render={({ field: otherField }) => (
                <TextField
                  {...otherField}
                  variant="outlined"
                  fullWidth
                  placeholder={otherPlaceholder}
                  error={Boolean(fieldError)}
                  helperText={fieldError ? fieldError.message : undefined}
                  multiline={otherMultiline}
                  minRows={otherMultiline ? otherRows : undefined}
                />
              )}
            />
          )}
        </RadioGroup>
      )}
    />
  );
}

RadioWithOtherField.defaultProps = {
  otherMultiline: false,
  otherRows: 4,
};

export default RadioWithOtherField;
